import React from 'react';
import { useHistory } from 'react-router-dom';

export default function ContentItemWithImage({ item, height }: { item: Record<string, any>, height?: string }) {
  const history = useHistory();

  const buttonClick = (callToAction) => (e) => {
    e.preventDefault();
    const url = callToAction.slug ? `/static/${ callToAction.slug }` : callToAction.value;

    history.push(url);
  };

  return (
    <button
      className="content-item__tile content-item__tile--image"
      style={ { backgroundImage: `url(${ item.background.url })`, minHeight: height } }
      onClick={ buttonClick(item.callToAction) }
      aria-label={ item.background.alternativeText }
      role="img"
    >
      { item.title && <div className="content-item__title content-item__title--image">{ item.title }</div> }
    </button>
  );
}
